import { createComponent } from '@carvana/merch-components';
import FavoriteVehicle from './FavoriteVehicle/FavoriteVehicle';
import VehicleImage from './VehicleImage/VehicleImage';
import { StatusTag } from '../Tags';

const FirstRowWrapper = createComponent('section', {
  className:
    'box-border grid grid-flow-row grid-rows-[min-content,max-content] relative'
});

const ContentWrapper = createComponent('div', {
  className: 'col-[1_/_3] grid relative'
});

const FirstRow = () => {
  return (
    <FirstRowWrapper>
      <VehicleImage />
      <ContentWrapper>
        <StatusTag />
        <FavoriteVehicle />
      </ContentWrapper>
    </FirstRowWrapper>
  );
};

export default FirstRow;
